import { formatLocalDateTime } from './localDateTime';
import { isTrmIntelligencePlaceholder } from '../../functions/src/common/trmIntelligence';
import { numericScore, qualitativeScoreLabel } from './scoreLabel';

export const TRM_MISSING_TEXT = 'Not Provided';

export function trmDisplayText(value: unknown, fallback = TRM_MISSING_TEXT) {
    const text = String(value ?? '');
    if (isTrmIntelligencePlaceholder(text))
        return fallback;
    return text.replace(/\bprovisional\s*[-—–:]\s*consultant\s+review(?:\s+required)?\b\s*:?[ \t]*/gi, '')
        .replace(/\bunverified\s*[-—–:]\s*consultant\s+review(?:\s+required)?\b/gi, TRM_MISSING_TEXT);
}

export const trmDisplayScore = (value: unknown, level?: unknown) => {
    const score = numericScore(value);
    return score === null ? qualitativeScoreLabel([value, level]) || 'N/A' : `${score}/100`;
};

export function trmDisplayDate(value: unknown) {
    return formatLocalDateTime(value, TRM_MISSING_TEXT);
}
